import CamposTorneoParticipante from '../campos/CamposTorneoParticipante.js';
import TablaTorneoParticipantes from '../tablas/TablaTorneoParticipantes.js';
import * as Campos from '../../constantes/Campos.js';

// Funciones para CuadroEditableLista

export const armarFilasTabla = (lista, idElegido, onEditarItem, onEliminarItem, contexto) => {
  return (
    <TablaTorneoParticipantes
      lista={lista}
      idElegido={idElegido}
      onEditarItem={onEditarItem}
      onEliminarItem={onEliminarItem}
      contexto={contexto}
    />
  );
};

export const OrdenarLista = (itemA, itemB) => {
  // Ordenar por posición final (nulls al final), luego por nombre de equipo
  const posA = itemA.posicionFinal !== null ? itemA.posicionFinal : 9999;
  const posB = itemB.posicionFinal !== null ? itemB.posicionFinal : 9999;
  if (posA !== posB) {
    return posA - posB;
  }
  // Obtener el nombre del equipo (puede estar en item.nombre o item.equipo.nombre)
  const nombreA = itemA.equipo?.nombre || itemA.nombre || '';
  const nombreB = itemB.equipo?.nombre || itemB.nombre || '';
  return nombreA.localeCompare(nombreB);
};

// Funciones para EditarItemLista

export const CamposEdicion = (idPadre, item, editar, actualizar, onCampoChange, contexto) => {
  return (
    <CamposTorneoParticipante
      idPadre={idPadre}
      item={item}
      editar={editar}
      actualizar={actualizar}
      onCampoChange={onCampoChange}
      contexto={contexto}
    />
  );
};

export const OnCampoChange = (item, campo, valor) => {
  switch (campo) {
    case Campos.TorneoParticipante.EQUIPO: {
      return { ...item, equipo: valor };
    }
    case Campos.TorneoParticipante.ORGANIZADOR: {
      return { ...item, organizador: valor };
    }
    case Campos.TorneoParticipante.TITULO_OBTENIDO: {
      return { ...item, tituloObtenido: valor };
    }
    case Campos.TorneoParticipante.MOVIMIENTO_DIVISIONAL: {
      return { ...item, movimientoDivisional: valor };
    }
    case Campos.TorneoParticipante.POSICION_FINAL: {
      return { ...item, posicionFinal: valor };
    }
    case Campos.TorneoParticipante.OBSERVACIONES: {
      return { ...item, observaciones: valor };
    }
    default: {
      throw new Error('Campo ' + campo + ' no definido');
    }
  }
};

export const ValidarItemGrabar = (item) => {
  let error = '';
  if (!item) {
    error = 'No se informaron datos para el participante';
  } else if (!item.equipo) {
    error = 'Debe seleccionar el equipo';
  }
  return error;
};
